import { z } from 'zod/mini'

export const planSelectionSearchSchema = z.object({
  error: z.optional(z.string()),
})
